/**
 * The attachment types and confidentiality labels of PRD §5.10.
 *
 * Ordered by how often a document of each kind gets filed rather than
 * alphabetically: a picker whose first option is the commonest choice saves a
 * scan on nearly every upload.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.8, PRD §5.10
 */
import type { AttachmentType, Confidentiality } from '@nexus/contracts';

export const ATTACHMENT_TYPES: readonly AttachmentType[] = [
  'PITCH_DECK',
  'NDA',
  'CONTRACT',
  'TECHNICAL',
  'COMMERCIAL',
  'REPORT',
] as const;

export const CONFIDENTIALITY_LABELS: readonly Confidentiality[] = [
  'INTERNAL',
  'CONFIDENTIAL',
] as const;

/**
 * What the file picker offers, from the server's allowlist.
 *
 * A hint, not a control: `accept` filters the dialog and nothing else, and a
 * user can always pick "all files". The server checks the type AND the bytes,
 * which is where the real refusal happens — this only spares someone choosing
 * a file that was never going to be accepted.
 */
export const ACCEPTED_FILE_EXTENSIONS = [
  '.pdf',
  '.docx',
  '.xlsx',
  '.pptx',
  '.doc',
  '.xls',
  '.ppt',
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.csv',
  '.txt',
].join(',');
